import PropTypes from 'prop-types'

import Button from 'views/components/atoms/Button'
import LoadingIndicator from 'views/components/atoms/LoadingIndicator'

const LoadingIndicatorButton = ({ loading, children, ...rest }) => (
  <Button {...rest}>
    {children}
    {loading && (
      <LoadingIndicator color="white" size={30} style={{ marginLeft: 10 }} />
    )}
  </Button>
)

LoadingIndicatorButton.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool.isRequired,
}

export default LoadingIndicatorButton
